import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Box from "@material-ui/core/Box";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { withStyles } from "@material-ui/core/styles";

import Button from "../../../../../../../../ui/Button";

const DialogTitle = withStyles(theme => ({
  root: {
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

export default function roomDialog({
  type,
  title,
  showResourceDialog,
  closeResourceDialog,
  allResourceTypeList,
  changeResourceType,
  changeResourceDescription,
  resource,
  lessonId,
  resourceId,
  addModuleResource,
  updateModuleResource
}) {
  const addResource = () => {
    const moduleResource = {
      lessonId: lessonId,
      main: {
        type: resource.main.type,
        description: resource.main.description
      }
    };
    addModuleResource(moduleResource);
    closeResourceDialog();
  };

  const updateResource = () => {
    const moduleResource = {
      main: {
        type: resource.main.type,
        description: resource.main.description
      }
    };
    updateModuleResource(resourceId, moduleResource);
    closeResourceDialog();
  };

  return (
    <div>
      <Dialog
        open={showResourceDialog}
        PaperProps={{ style: { minWidth: 400 } }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Grid container justify="space-between">
            <Grid item xs={12}>
              <Box mb={1}>
                <Autocomplete
                  options={allResourceTypeList}
                  disableClearable
                  getOptionLabel={option => (option ? option.name : option)}
                  value={
                    resource &&
                    (allResourceTypeList.find(
                      item => item.id === resource.main.type
                    ) ||
                      "")
                  }
                  onChange={(event, item) => changeResourceType(event, item.id)}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Вид оборудования/ПО"
                      InputLabelProps={{
                        shrink: true
                      }}
                      fullWidth
                      required
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <TextField
                  name="description"
                  required
                  label="Краткое описание"
                  value={resource && resource.main.description}
                  onChange={changeResourceDescription}
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  multiline
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeResourceDialog}>Отмена</Button>
          <Button
            onClick={() => (type === "add" ? addResource() : updateResource())}
            color="green"
          >
            {type === "add" ? "Добавить" : "Обновить"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
